// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Date Mall",
        "pull_refresh": "Trageți în jos pentru a reîmprospăta",
        "release_refresh": "Eliberare pentru a reîmprospăta",
        "refresh_loading": "Încărcare...",
        "footer_text": "Servicii furnizate de Ucloudlink (NASDAQ: UCL)"
      },
      "home": {
        "input_placeholder": "Căutați țara/regiunea",
        "my_flow": "Datele mele",
        "charge_code": "Cod voucher",
        "coupons": "Cupoane",
        "local_package": "Date locale",
        "more": "Mai mult",
        "popular_destination": "Țară/regiune",
        "buy_now": "Cumpărați acum",
        "package_useing": "Activ",
        "unused": "Inactiv",
        "download_app": "Descărcați aplicația",
        "enter_the_mall_list": "Intrați în lista mall-ului",
        "no_data": "Încă nu există date",
        "no_data_available": "Nu sunt disponibile date",
        "copy_success": "Copiați cu succes",
        "copy_fail": "Eșec la copiere",
        "meritsTitle": "Care sunt avantajele?",
        "merits1": "Fără SIM necesar & Fără taxă lunară",
        "merits2": "Integrat cu top 2-3 operatori pentru comutare automată de rețea",
        "go_buy": "Cumpărați",
        "instant_savings": "Economisește",
        "expires_in": "Expiră în",
        "download_app_tips": "Descărcați aplicația pentru mai multe oferte și experiențe"
      },
      "packages": {
        "sub_title": {
          "us": "Excluzând Guam, Saipan",
          "it": "Inclusiv Vatican City, San Marino",
          "va": "Inclusiv Italia, San Marino",
          "sm": "Inclusiv Italia, Vatican City",
          "ma": "Inclusiv Sahara de Vest",
          "eh": "Inclusiv Maroc",
          "ch": "Inclusiv Liechtenstein",
          "li": "Inclusiv Elveția",
          "fr": "Inclusiv Monaco",
          "mc": "Inclusiv Franța",
          "fi": "Inclusiv Insulele Aland",
          "ax": "Inclusiv Finlanda",
          "gu": "Inclusiv Insulele Marianei de Nord",
          "mp": "Inclusiv Guam"
        },
        "unlimited_packages": "Pachet de date nelimitat",
        "normal_packages": "Pachet normal de date",
        "multi_region_packages": "Regiune multiplă",
        "regional_data": "Date regionale",
        "high_speed_text": "date de mare viteză",
        "infiniteFlow": "Date nelimitate",
        "unLimitData": "Nelimitat",
        "high_speed_text_year": "Viteză mare/MP",
        "package_list": "Lista pachetelor",
        "special_offer": "Promoții",
        "first_month": "1-luni",
        "periodUnit": {
          "day": "Ziua (zilele)",
          "month": "lună",
          "hour": "Ora (orele)",
          "year": "an"
        },
        "periodUnits": {
          "day": "Ziua (zilele)",
          "month": "luni",
          "hour": "Ora (orele)",
          "year": "ani"
        },
        "periodUnitSimp": {
          "day": "d",
          "month": "mo",
          "hour": "h",
          "year": "yr"
        },
        "periodUnitMonthly":"Lunar",
        "periodUnitsSimp": {
          "day": "d",
          "month": "mo",
          "hour": "h",
          "year": "yr"
        },
        "unlimited_good_name": {
          "day": "Trece de zi",
          "month": "Pasaj lunar",
          "year": "Trecere anuală"
        },
        "continuousMonth": "Luni continue",
        "continuousDay": "Zile continue",
        "continuousYear": "Ani continue",
        "day_invalid": "Expiră în ziua curentă",
        "month_invalid": "Expiră în luna curentă",
        "immediate_valid": "Efectiv imediat",
        "tomorrow_day_valid": "Efectiv din ziua următoare",
        "tomorrow_month_valid": "Efectiv față de luna viitoare",
        "detail": {
          "cell_flow": "Date",
          "cell_period": "Valabilitate",
          "buy_quantity": "Cantitate",
          "use_area": "Acoperire",
          "use_intro": "Termeni și condiții",
          "buy_btn": "Comanda",
          "pay": "Plăti",
          "buy_tips": "Ai pachetul %@packageName în uz. Vrei să cumperi acest pachet?",
          "haveOrderTips": "Comandă cu plată în așteptare generată. Click Confirma pentru a accesa pagina mea de date！"
        },
        "confirm": {
          "title": "Confirmarea comenzii",
          "real_pay_amount": "Suma plătită",
          "online_payment": "Plata online",
          "create_order_error": "Configurarea a eșuat"
        }
      },
      "pay": {
        "result": {
          "loading_order_status": "Obținerea statutului comenzii...",
          "buy_success": "Comanda completă",
          "buy_pending": "În așteptarea confirmării",
          "buy_pending_tip": "Plata în proces... Dacă plata nu a fost transferată în 10 minute, vă rugăm să ne contactați pentru asistență.",
          "get_payment_info_fail": "Achiziția informațiilor de plată a eșuat",
          "cell_package": "Pachet",
          "cell_buy_amount": "Subtotal",
          "cell_real_amount": "Suma plătită",
          "go_to_order_btn": "Mergeți la pachetul meu",
          "back_home": "Înapoi acasă",
          "back_mall": "Înapoi la centrul comercial",
          "ordersn_empty": "Comanda SN nu poate fi goală",
          "order_search_error": "Eroare neașteptată",
          "goodsName": 'Numele produsului'
        },
        "fail": {
          "payment_fail": "Plata a eșuat",
          "back_home": "Înapoi acasă"
        }
      },
      "CountryGroup": {
        "title": "Țară/regiune",
        "placeholder": "Căutați țară sau regiune",
        "clear": "Clar",
        "history": "Istoricul căutării"
      },
      "PromotionCode": {
        "verification": {
          "title": "Cod voucher",
          "minititle": "Cod voucher",
          "input": "Vă rugăm să introduceți codul de top-up",
          "explain": "Sfaturi: Atingeți butonul de scanare din dreapta sus pentru a scana codul QR al cardului voucher sau introduceți manual codul voucherului (sensibil la caz) dacă nu funcționează.",
          "submit": "Depune",
          "exchange": "Răscumpăra",
          "cancel": "Anula",
          "Inquiry": "Sunteți sigur că schimbați",
          "ErrorCode": "Reîncărcați codul de eroare"
        },
        "recharge_success": {
          "package": "Pachet",
          "content": "Răscumpărat cu succes",
          "back": "Înapoi la centrul comercial",
          "view_packets": "Mergeți la pachetul meu"
        }
      },
      "order": {
        "state": {
          "inUse": "Activat",
          "isFirst": "Prioritare",
          "toFirst": "Prioritate stabilită",
          "inactive": "Inactivat"
        },
        "periodUnits": {
          "minute": "Minute (S)",
          "hour": "Ora (orele)",
          "day": "Ziua (zilele)",
          "month": "luna (luna)"
        },
        "useIntro": {
          "tip1": "Pachetul de date nelimitat are o prioritate mai mare decât pachetul de date de volum.",
          "tip2": "Prioritatea de utilizare se va baza pe data de achiziție pentru același tip de pachet, adică pachetul cu cea mai timpurie dată de cumpărare va fi utilizat mai întâi, în timp ce prioritatea pachetelor cu o singură regiune este mai mare decât pachetul regional.",
          "tip3": "De asemenea, puteți ajusta manual prioritatea utilizării pachetelor de același tip."
        },
        "myFlow": "Datele mele",
        "remainingFlow": "Date rămase",
        "remainingTime": "Stânga valabil",
        "remainingHighFlow": "Date de mare viteză rămase",
        "validPeriod": "Valabilitate",
        "noneFlow": "Fără pachet de date",
        "noneFlowTip": "Vă rugăm să cumpărați pachetul de date și să vă bucurați de rețeaua de înaltă calitate",
        "buyPackFlow": "Cumpărați pachete",
        "checkInvalidFlow": "Verificați pachetul de date expirat",
        "orderList": {
          "title": "ordinele mele",
          "amount_paid": "Total",
          "device": "Dispozitiv deținut",
          "order_details": "Detalii comanda",
          "total_amont": "Subtotal",
          "orderSN": "Ordinul nr.",
          "createTime": "Timpul de creație",
          "cancelTime": "Ora închisă",
          "payTime": "Ora comenzii",
          "unsubTime": "Timp anulat",
          "payMethod": "Modalitate de plată",
          "thirdSN": "Tranzactia nr.",
          "delete": "Şterge",
          "cancel": "Anulează comanda",
          "unsub": "Restituire",
          "goto_cancel": "Doriți să anulați comanda?",
          "goto_unsubscribe": "Doriți să dezabonați comanda?",
          "delete_Tips": "Comanda nu poate fi reluată după ce a fost ștearsă, prin urmare problemele dumneavoastră după service nu pot fi rezolvate.Ești sigur că îl ștergi?",
          "status_success": "Terminat",
          "status_pending": "Neplătit",
          "status_cancel": "Închis",
          "status_unsub": "Anulat",
          "payMethod_stripe": "Card de credit"
        },
      },
      "registerlogin": {
        "create_account_tip":"Creați un cont, începeți experiență exclusivă",
        "select_country_tip":"Utilizarea dispozitivului țări/regiune",
        "email_name": "E -mail",
        "phone_name": "Telefon",
        "email_address": "Adresa de e-mail",
        "password": "parolă",
        "country": "ţară",
        "select_country": "Alegeți o țară",
        "cancel": "Anula",
        "confirm": "Sigur",
        "please_enter": "Vă rugăm să introduceți 6-20 de caractere (combinație de litere, numere sau simboluri)",
        "select_country_tips": "Selecția țării este pentru vizualizarea pachetelor locale. Nu poate fi schimbat după înregistrare. Vă rugăm să confirmați!",
        "global_roaming": "Cod internațional de domeniu",
        "phone_number": "număr de telefon",
        "agree": "de acord",
        "user_agreement": "Acord de utilizator",
        "and": "şi",
        "privacy_policy": "Politica de confidențialitate",
        "register_login": "Înscrieți -vă sau conectați -vă",
        "login_error": "Numărul de autentificări este prea frecvent, vă rugăm să încercați din nou mai târziu!",
        "register_error": "Numărul de înregistrări este prea frecvent, vă rugăm să încercați din nou mai târziu!",
        "forgot_pwd": "Uitați parola",
        "app_tips": "Conectați -vă la aplicație cu acest cont după ce l -ați descărcat pentru a accesa mai multe funcții.",
        "download_app": "Mergeți să descărcați aplicația",
        "rememberPwd": "Amintiți -vă parola",
        "third_login": "Continuați cu",
        "agreement_tips": "Vă rugăm să bifați caseta Acordul de utilizator și Politica de confidențialitate",
        "selectCountry_tips": "Vă rugăm să rețineți că țara înregistrată va afecta direct următoarele metode și monede de plată, vă rugăm să selectați în funcție de nevoia dvs.",
        "login_error_cancel": "Utilizatorul a anulat autentificarea",
        "login_error_auth": "Permiteți popup-urile din setările browserului",
        "device_tips": "Dispozitiv în așteptare activare. Procesare în 24 de ore."
      },
      "forgotPwd": {
        "forgot_pwd": "Uitați parola",
        "email_address": "Adresa de e-mail",
        "next": "Următorul",
        "email_has_been_sent": "Am trimis un e -mail la %@email. Vă rugăm să faceți clic pe link și să urmați pașii pentru a vă prelua parola.",
        "have_retrieved_it": "Am găsit -o",
        "unable_to_receive_email": "Nu puteți primi e -mailul? Vă rugăm să verificați dacă există e -mailuri de la %@email sub spam și directorul de e -mail șters",
        "or": "sau",
        "resend": "Revendic",
        "global_roaming": "Cod internațional de domeniu",
        "phone_number": "număr de telefon",
        "verification_code_has_been_sent": "Am trimis codul de verificare la:",
        "verification_code": "Cod de verificare",
        "no_verification_code_received": "Nu ați primit codul de verificare?",
        "please_enter": "Vă rugăm să introduceți 6-20 de caractere (combinație de litere, numere sau simboluri)",
        "reset_password": "Resetați parola",
        "reset_successful": "Resetați cu succes"
      },
      "coupons": {
        "coupons_name": "Cupoane",
        "no_coupons": "Încă nu există cupoane",
        "no_data": "Încă nu există date",
        "applicable_to_the_following": "Cupoanele sunt potrivite pentru următorul pachet de date"
      },
      "digital":{
        "title":"Dispozitiv SN",
        "purchased":"Cumpărăturile mele",
        "viewAll":"Mai mult",
        "skinStore":"Magazin de produse",
        "completed":"Cumpărat",
        "goBuy":"Cumpăra",
        "order": {
          "title":"Comenzi achiziționate"
        },
        "detail": {
          "describe":"Descriere"
        }
      },
      "viewPL": {
        "other": 'alte'
    },
      "invalidFlow": {
        "stateName": "Statut",
        "state": {
          "NOT_ACTIVATED": "Inactivat",
          "IN_USING": "Disponibil",
          "USE_END": "Epuizat",
          "EXPIRE": "Expirat",
          "TRANSFER": "Transfer",
          "UNSUBSCRIBE": "Anula",
          "VALID": "Valabil",
          "INVALID": "Invalid",
          "EXCHANGE_POINTS": "Răscumpăra puncte"
        },
        "noneFlow": "Fără pachet de date expirat",
        "pageName": "Pachet de date expirat"
      },
      "flowDetail": {
        "title": "Detalii despre date",
        "flow": "Date",
        "validTime": "Începe valid",
        "invalidTime": "Valabil până",
        "coverage": "Acoperire",
        "useIntro": "Termeni și condiții",
        "purchaseTime": "Cumpărat la",
        "subtotal": "Subtotal",
        "status": "Statut",
        "cancel": "Anula",
        "buyAgain": "Cumpără -l din nou",
        "validity": "Valabilitate",
        "tip": "Observa",
        "cancelTip": "Ești sigur că vrei să rambursezi acest pachet?",
        "dataLeft": "Date rămase"
      },
      "netError": {
        "try_again": "Încearcă din nou",
        "net_error": "Fără rețea",
        "try_again_desc": "Vă rugăm să verificați setarea rețelei și să încercați din nou"
      },
      "loadFail": {
        "try_again": "Încearcă din nou",
        "load_fail": "Încărcarea a eșuat",
        "load_fail_desc": "Încărcarea datelor a eșuat, vă rugăm să încercați din nou",
        "IMEI_Not_Exist": "IMEI nu există, vă rugăm să încercați să intrați din intrarea potrivită",
        "Project_Not_Exist": "Apare o eroare. Vă rugăm să contactați Serviciul Clienți. (01)",
        "commonError": "Apare o eroare. Vă rugăm să contactați serviciul clienți."
      },
      "settlement_Easy_and_convenient": "Ușor și convenabil",
      "settlement_Great_deal": "Mare lucru",
      "settlement_Safe_and_secure": "Sigur și sigur",
      "settlement_Autopay_service_regulation": "Reglementarea serviciilor automate",
      "settlement_Read": "Citire",
      "settlement_No_coupon": "Fără cupon disponibil",
      "settlement_Subtotal": "Subtotal",
      "settlement_Coupon": "Cupoane",
      "settlement_TOTAL": "Total",
      "settlement_promotion_tip": "Oferta promoțională nu poate fi utilizată împreună cu niciun cupoane",
      "settlement_coupon_tip": "Cuponul nu poate fi utilizat împreună cu orice alte oferte promoționale",
      "member_myFlow_noList": "Fără date",
      "detail_se_content": "Un mod sigur, ușor și convenabil. Vă puteți dezabona în orice moment",
      "Enter_Promo_code": "Cod de promovare",
      "Enter_Promo_Coupon": "Cupoane",
      "settlement_Not_used_coupon": "cuponul nu este folosit",
      "settlement_Available_coupon": "Disponibil",
      "settlement_Unavailable_coupon": "Indisponibil",
      "please_Enter_Promo_code": "Vă rugăm să introduceți codul de promovare",
      "please_Select_Coupon_use": "Vă rugăm să selectați cuponul pe care doriți să îl utilizați.",
      "Buy_Now": "Cumpărați acum",
      "Dont_Use_Any": "Nu folosiți niciunul",
      "settlement_confirm": "Confirma",
      "settlement_tips": "Confirma",
      "flowDetail_unsubscribe": "Dezabonați -vă",
      "flowDetail_unsubscribed": "Nesubscris",
      "flowDetail_isCancelPackage": "Dezabonați acest pachet?",
      "flowDetail_confirmAgreementUnsubscribe": "Nu puteți avea mare lucru după dezabonare. Ești sigur că vrei să te dezabonezi?",
      "flowDetail_cancel": "Anula",
      "flowDetail_cancelSuccess": "Dezabonați -vă cu succes",
      "packages_detail_promotion": "Promovare",
      "orderTips":{
        "iDay" : "zi",
        "iDays" : "zile",
        "iMonth" : "lună",
        "iMonths" : "luni",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol la prima dvs. cumpărare, Plătiți %@money/%@periodSymbol mai târziu, Vă puteți dezabona în orice moment",
        'Monthly_discount':"Economisiți %@saveMoney fiecare %@period! Vă puteți dezabona în orice moment",
        'Ordinary_monthly_package':"Un mod sigur, ușor și convenabil. Vă puteți dezabona în orice moment",
        "AlreadyPurchased":'Ne pare rău că vă puteți abona doar la un pachet de date în acest moment. Vă rugăm să vă dezabonați de la “%@” și să vă abonați mai târziu la orice pachet pe care îl doriți după expiră.',
        "Contract_recommendation_First":'<label>Cu serviciul autopay, la prima dvs. cumpărare, plătiți numai</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Vă puteți dezabona în orice moment'
        +'<a class="btn">Abonați -vă ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Cu serviciul autopay, plătiți numai</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Vă puteți dezabona în orice moment'
        +'<a class="btn">Abonați -vă ></a></p>',
        "Contract_recommendation_General":"<label>Cu serviciul autopay</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Un mod sigur, ușor și convenabil. Vă puteți dezabona în orice moment'
        +'<a href="javascript:;" class="btn">Abonați -vă ></a></p>',
        'BanlanceDoubleCheck':'Ești sigur că vrei să plătești cu sold?',
    },
    feedback: {
      title: "feedback",
      placeholder: "Vă rugăm să intrați în țara pe care doriți să o vizitați sau în orice alte întrebări și vă vom satisface nevoile cât mai curând posibil!",
      submit: "Trimite",
      submit_success: "Trimite cu succes",
      other_opinions: "Alte opinii",
    },
    view_country_input: 'Vă rugăm să introduceți contul dvs',
    "select_package": {
      "title": "Selectați Datele",
      "allPackage": "Toate Datele",
      "type": "Tip",
      "flow": "Date",
      "month_package": "Plan lunar",
      "flow_package": "Pachet date",
      "time": "Durată",
      "period": "Ciclus",
      "auto_debit": "Info Debit Automat",
      "auto_subscribe": "Auto-Reînnoire",
      "detail": "Detalii Date",
      "carrier": "Operatori Susținuți",
      "country": "Țări Acoperite",
      "notice": "Ghid de Cumpărare"
    }
}